import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { GetProjectMarketCapacityReportParams } from '@/shared/api/end-points/project'
import { MarketCapacityResponse } from '../../lib'

const getMarketCapacityReport = async (params: GetProjectMarketCapacityReportParams) => {
  return await api.json<MarketCapacityResponse>(API_END_POINTS.project.getProjectMarketCapacityReport(params))
}

export default getMarketCapacityReport
